namespace appn.views.taskTemplates.activities {

    class InitArgs {
        activityTypes: Array<SelectListItem> = [];
        formsList: Array<SelectListItem> = [];
        docsList: Array<SelectListItem> = [];
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;
        appn.folderFilter.initLinkedFolders();
        addEvents();
    }

    function addEvents() {
        $('.addValue').on('click', function(event) {
            event.preventDefault();

            const items = $('#actItems tbody');
            const idx = items.children().length;
            let html: string = appn.emptyString;

            for (let i = 0; i < _initArgs.activityTypes.length; i++)
                html += `<option value="${_initArgs.activityTypes[i].value}">${_initArgs.activityTypes[i].text}</option>`;

            html = `<tr>` +
                `<td class="typeCell">` +
                `<select class="activityType form-control form-control-sm" name="Template.Task.Activities[${idx}].ActivityType" id="Template_Task_Activities_${idx}__ActivityType" data-val-required="${T("The {0} field is required.", "Activity Type")}" data-val="true">` +
                `<option value="">${appn.strings.choose}</option>${html}</select>` +
                `</td>` +
                `<td class="detailsCell form-flex" id="Cell_${idx}"></td>` +
                `<td class="td-optional">${elementBuilder.buildCheckbox('', 'actIsOptional', `Template_Task_Activities_${idx}__IsOptional`, elementBuilder.ICheckColor.primary, `Template.Task.Activities[${idx}].IsOptional`, true)}</td >` +
                `<td class="activity-row-options">` +
                '<div class="btn-group" role="group">' +
                `${elementBuilder.buildBtnMoveRow(true)}` +
                `${elementBuilder.buildBtnMoveRow(false)}` +
                elementBuilder.buildBtnRemoveRow('delete_button') +
                '</div>' +
                `</td>` +
                `</tr>`;

            $('#actItems tbody').append(html);

            select.init({
                selector: '#actItems tbody select'
            });

            appn.ui.checkboxForceOnChanged('.actIsOptional');
        });

        $(document).on('click', '.down_button', function() {
            const rowToMove = $(this).parents('#actItems tbody tr:first');
            const next = rowToMove.next('#actItems tbody tr');
            if (next.length === 1) {
                next.after(rowToMove);
                renameRows();
            }
        });

        $(document).on('click', '.up_button', function() {
            const rowToMove = $(this).parents('#actItems tbody tr:first');
            const prev = rowToMove.prev('#actItems tbody tr');
            if (prev.length === 1) {
                prev.before(rowToMove);
                renameRows();
            }
        });

        $(document).on('click', '.taskActivityTable .delete_button', function() {
            $(this).parents('tr').remove();
            renameRows();
            select.init();
        });

        $(document).on('change', '.activityType', function() {
            const idx = $(this)?.attr('id')?.replace('Template_Task_Activities_', '').replace('__ActivityType', '') ?? 0;
            setDetails(($(this).val() as string), (idx as number));
        });

    }

    function renameRows(): void {
        // rename all remaining rows to keep continuous index
        let idx = 0;

        select.destroy('#actItems tbody tr select');

        $('#actItems tbody tr').each(function(index, row) {
            $(this).find('.detailsCell')
                .attr('id', `Cell_${idx}`);

            const activityType = $(this).find('.typeCell select');
            const activityValue = activityType.val();

            activityType.attr('name', `Template.Task.Activities[${idx}].ActivityType`)
                .attr('id', `Template_Task_Activities_${idx}__ActivityType`);

            if (activityValue === 'FillOutForm' || activityValue === 'ReadDoc') {
                $(this).find('.detailsCell select')
                    .attr('name', `Template.Task.Activities[${idx}].RelatedId`)
                    .attr('id', `Template_Task_Activities_${idx}__RelatedId`);

                $(this).find('.detailsCell input')
                    .attr('name', `Template.Task.Activities[${idx}].Name`)
                    .attr('id', `Template_Task_Activities_${idx}__Name`);

            } else if (activityValue === 'Instruction')
                $(this).find('.detailsCell textarea')
                    .attr('name', `Template.Task.Activities[${idx}].Details`)
                    .attr('id', `Template_Task_Activities_${idx}__Details`);

            $(this).find('.td-optional input')
                    .attr('name', `Template.Task.Activities[${idx}].IsOptional`)
                    .attr('id', `Template_Task_Activities_${idx}__IsOptional`);

            $(this).find('.hidden-activity-id')
                    .attr('name', `Template.Task.Activities[${idx}].Id`)
                    .attr('id', `Template_Task_Activities_${idx}__Id`);

            $(this).find('.hidden-activity-keyId')
                    .attr('name', `Template.Task.Activities[${idx}].KeyId`)
                    .attr('id', `Template_Task_Activities_${idx}__KeyId`);

            $(this).find('.hidden-activity-completeTicks')
                    .attr('name', `Template.Task.Activities[${idx}].CompleteTicks`)
                    .attr('id', `Template_Task_Activities_${idx}__CompleteTicks`);

            idx++;
        });

        select.init();
    }

    function setDetails(activityType: string, idx: number) {
        let html = emptyString;
        let selector = emptyString;

        switch (activityType) {
            case 'FillOutForm':
                for (let i = 0; i < _initArgs.formsList.length; i++)
                    html += `<option value="${_initArgs.formsList[i].value}">${_initArgs.formsList[i].text}</option>`;

                html = `<select class="form-control form-control-sm" name="Template.Task.Activities[${idx}].RelatedId" id="Template_Task_Activities_${idx}__RelatedId" data-val-required="${T("The Activity Details field is required.")}" data-val="true"><option value="">${appn.strings.choose}</option>${html}</select>` + 
                    `<input class="form-control form-control-sm ml-2" id="Template_Task_Activities_${idx}__Name" name="Template.Task.Activities[${idx}].Name" placeholder="${T("Optional activity name...")}" type="text"/>`; 
                selector = `Template_Task_Activities_${idx}__RelatedId`;

                break;

            case 'ReadDoc':
                for (let i = 0; i < _initArgs.docsList.length; i++)
                    html += `<option value="${_initArgs.docsList[i].value}">
                    ${_initArgs.docsList[i].text}</option>`;

                html = `<select class="form-control form-control-sm" name="Template.Task.Activities[${idx}].RelatedId" id="Template_Task_Activities_${idx}__RelatedId" data-val-required="${T("The Activity Details field is required.")}" data-val="true"><option value="">${appn.strings.choose}</option>${html}</select>` +
                    `<input class="form-control form-control-sm ml-2" id="Template_Task_Activities_${idx}__Name" name="Template.Task.Activities[${idx}].Name" placeholder="${T("Optional activity name...")}" type="text"/>`;
                selector = `Template_Task_Activities_${idx}__RelatedId`;

                break;

            case 'Instruction':
                html = `<textarea class="form-control form-control-sm" name="Template.Task.Activities[${idx}].Details" id="Template_Task_Activities_${idx}__Details" rows="1" data-val-required="${T("The Activity Details field is required.")}" data-val="true" data-val-length-max="500" data-val-length="${T("The field must be a string with a maximum length of 500.")}" data-val="true" cols="50"></textarea>`;
                break;

        }

        const detailsCell = $(`#Cell_${idx}`);
        detailsCell.html(html);

        if (selector)
            select.init({
                selector: `#${selector}`
            });
    }
}
